<template>
  <div class="wrap">
    <ul class="drop-list">
      <li class="drop" v-for="drop in pageDrops" v-link="{ name: 'drops', params: { title: drop.id + '.' + drop.title }}">
        {{fdrops.length - $index}}.{{drop.title}}<span>{{drop.date}}</span>
      </li>
    </ul>
    <a class="loadmore" @click="loadMore()">
      Load More
    </a>
  </div>
</template>

<style lang="styl" scoped>
  .wrap
    max-width: 1260px
    margin: 0 auto
    padding: 0 20px
  .drop-list
    margin: 40px auto 0
    max-width: 800px
    list-style-type: none
    > li
      word-break: keep-all
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      letter-space: .3px
      padding: 15px 0px
      line-height: 20px
      font-size: 16px
      text-rendering: optimizeSpeed
      transition: color .3s ease
      cursor: pointer
      &:hover
        color: #05A5D1
      &:active
        color: paper
      > span
        float: right
        font-size: 12px
        color: rgba(0,0,0,.7)
  .loadmore
    display: block
    text-decoration: none
    z-index: 99
    padding: 5px
    line-height: 20px
    letter-spacing: .03em
    word-spacing: .02em
    font-size: 14px
    transition: all .2s ease-in-out
    text-align: center
    color: #aaa
    margin: 20px auto 30px
    max-width: 800px
    cursor: pointer
    border: 1px solid #aaa
    width: 200px
    border-radius: 5px
    &:hover
      color: #05A5D1
      border-color: #05A5D1
    &:active
      color: #fff
      border-color: #05A5D1
      background: #05A5D1
  .drop
    box-sizing: border-box
  .drop-transition
    transition: opacity .5s ease
  .drop-enter
    opacity: 0
  .drop-leave
    opacity: 0
    position: absolute
  .drop-move
    color: red
    transition: transform .5s cubic-bezier(.55,0,.1,1)
  @media (max-width: 650px)
    .drop-list > li
      border-bottom: 1px solid #efefef
</style>

<script>
  export default{
    name: 'DropList',

    props: {
      search: {
        type: String
      }
    },

    data () {
      return {
        drops: [],
        page: 1,
        pageLen: 50
      }
    },

    created () {
      let _drops = localStorage.getItem('drops')
      if (!_drops) {
        this.$http.get('static/drops.json')
          .then(res => {
            this.drops = res.json().drops.map(item => {
              let _id = item.split('.')[0]
              return {
                id: _id,
                title: item.slice(_id.length + 1, item.length - 10),
                date: item.slice(-10)
              }
            })
            localStorage.setItem('drops', JSON.stringify(this.drops))
          })
      } else {
        this.drops = JSON.parse(_drops)
      }
    },

    computed: {
      fdrops () {
        this.page = 1
        return this.drops.filter(item => {
          return item.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        })
      },
      pageDrops () {
        return this.fdrops.slice(0, this.page * this.pageLen)
      }
    },

    methods: {
      loadMore () {
        this.page++
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** DropList.vue?097c7abc
 **/